import { clone, isEmpty, isNil } from "ramda";
import * as turf from "@turf/turf";
import worldLand from "../../../../../config/georef-spain-provincia.json";
export const handleChannels = ({
  e,
  zones,
  setZones,
  zoneToggle,
  selectedEquipment,
  errors,
  setErrors,
  indexAssetSub,
  setZoneToggle,
  assetSub,
  polylineDisplay,
}) => {
  const newErrors = { ...errors };
  if (isEmpty(e.target.value)) {
    newErrors[e.target.id] = "not.empty";
  } else {
    delete newErrors[e.target.id];
  }
  setErrors(newErrors);
  let newZones = clone(zones);

  let newZoneToggle = clone(zoneToggle);
  const subKey = `sub${indexAssetSub + 1}`;
  newZones[subKey] = [];
  for (let newValue = 0; newValue < parseInt(e.target.value); newValue++) {
    if (isNil(zones[subKey][newValue])) {
      if (isNil(zones[subKey][newValue - 1])) {
        newZones[subKey][newValue] = {
          ini: 0,
          end: 10,
          alertsConfigurations: null,
        };
      } else {
        newZones[subKey].push({
          ini: newZones[subKey][newValue - 1].end + 1,
          end: newZones[subKey][newValue - 1].end + 2,
          alertsConfigurations: null,
        });
        minHandler({
          e: null,
          zones: newZones,
          setZones,
          indexAssetSub,
          zoneIndex: newZones[subKey].length - 1,
          errors,
          setErrors,
        });
        maxHandler({
          e: null,
          zones: newZones,
          setZones,
          indexAssetSub,
          selectedEquipment,
          zoneIndex: newZones[subKey].length - 1,
          polylineDisplay,
          assetSub,
          errors,
          setErrors,
        });
      }
    } else {
      newZones[subKey].push(zones[subKey][newValue]);
    }
    // Nota: zoneToggle sigue anidado por posición de navegación (equipo/canal/sub visual),
    // este nivel no cambia aquí; se mantiene igual que en el llamador.
    // Si zoneToggle también pasó a ser plano, cambia la línea de abajo por: newZoneToggle[indexAssetSub]
    if (isNil(newZoneToggle[indexAssetSub]?.[newValue])) {
      newZoneToggle[indexAssetSub] = newZoneToggle[indexAssetSub] ?? [];
      newZoneToggle[indexAssetSub].push(false);
    }
  }
  setZoneToggle(newZoneToggle);
  setZones(newZones);
};

export const minHandler = ({ e, zones, setZones, indexAssetSub, zoneIndex, errors, setErrors }) => {
  const subKey = `sub${indexAssetSub + 1}`;
  const prevId = `sub${indexAssetSub}_${zoneIndex - 1}_1`;
  const id = `sub${indexAssetSub}_${zoneIndex}_0`;
  const nextId = `sub${indexAssetSub}_${zoneIndex}_1`;
  const newErrors = { ...errors };
  if (!isNil(e) && isEmpty(e.target.value)) {
    newErrors[id] = "not.empty";
  }
  let newZones = zones;
  const value = !isNil(e) ? parseFloat(e.target.value) : newZones[subKey][zoneIndex].ini;
  const previousZone = newZones[subKey][zoneIndex - 1];

  if (isNil(previousZone) && value < newZones[subKey][zoneIndex].end) {
    delete newErrors[id];
    delete newErrors[nextId];
  } else if (isNil(previousZone) && value >= newZones[subKey][zoneIndex].end) {
    newErrors[id] = "min.lower.max";
  }
  if (!isNil(previousZone)) {
    if (previousZone.end < value && value < newZones[subKey][zoneIndex].end) {
      delete newErrors[prevId];
      delete newErrors[id];
      delete newErrors[nextId];
    } else if (previousZone.end >= value || value <= newZones[subKey][zoneIndex].end) {
      newErrors[id] = "prevMax.thisMax";
    }
  }
  newZones[subKey][zoneIndex].ini = value;
  setZones(newZones);
  setErrors(newErrors);
};

export const maxHandler = ({
  e,
  zones,
  setZones,
  indexAssetSub,
  selectedEquipment,
  zoneIndex,
  polylineDisplay,
  assetSub,
  errors,
  setErrors,
}) => {
  const subKey = `sub${indexAssetSub + 1}`;
  const prevId = `sub${indexAssetSub}_${zoneIndex}_0`;
  const id = `sub${indexAssetSub}_${zoneIndex}_1`;
  const nextId = `sub${indexAssetSub}_${zoneIndex + 1}_0`;
  const newErrors = { ...errors };
  if (!isNil(e) && isEmpty(e.target.value)) {
    newErrors[id] = "not.empty";
  }
  let newZones = zones;
  const value = !isNil(e) ? parseFloat(e.target.value) : newZones[subKey][zoneIndex].end;
  const nextZone = newZones[subKey][zoneIndex + 1];

  if (isNil(nextZone) && value > newZones[subKey][zoneIndex].ini) {
    delete newErrors[prevId];
    delete newErrors[id];
  } else if (isNil(nextZone) && value <= newZones[subKey][zoneIndex].ini) {
    newErrors[id] = "max.higher.min";
  }
  if (!isNil(nextZone)) {
    if (nextZone.ini > value && value > newZones[subKey][zoneIndex].ini) {
      delete newErrors[prevId];
      delete newErrors[id];
      delete newErrors[nextId];
    } else if (nextZone.ini <= value || value <= newZones[subKey][zoneIndex].ini) {
      newErrors[id] = "thisMin.nextMin";
    }
  }

  const provName = assetSub.type === "generic" ? assetSub.polyline : assetSub.depth;
  const realIndex = polylineDisplay.findIndex(
    (polyline) => polyline.id === provName && polyline.equipment_type === selectedEquipment.equipmentType,
  );
  if (assetSub.type === "generic") {
    if (value > polylineDisplay[realIndex].points[polylineDisplay[realIndex].points.length - 1].pk) {
      newErrors[id] = "higher.than.highest.pk";
    }
  } else {
    if (value > provName) {
      newErrors[id] = "deeper.than.depth.defined";
    }
  }

  newZones[subKey][zoneIndex].end = value;
  setZones(newZones);
  setErrors(newErrors);
};

export const handleChannelDisability = ({
  actualID,
  equipment,
  indexEquipment,
  indChan,
  equipmentInterMeasurement,
  setEquipment,
  setEquipmentInterMeasurement,
  newState,
  errors,
  setErrors,
}) => {
  const newEquipments = [...equipment];
  const updatedEquipment = { ...newEquipments[indexEquipment] };
  const actualMeasureFrequency = updatedEquipment.channels[indChan].measurement.measurementTime;
  let newEquipmentInterMeasurement = clone(equipmentInterMeasurement);
  if (!newState) {
    newEquipmentInterMeasurement[indexEquipment] =
      newEquipmentInterMeasurement[indexEquipment] + actualMeasureFrequency;
  } else {
    newEquipmentInterMeasurement[indexEquipment] =
      newEquipmentInterMeasurement[indexEquipment] - actualMeasureFrequency;
  }
  updatedEquipment.channels[indChan].measurement.state = newState;
  const newErrors = { ...errors };
  if (isEmpty(updatedEquipment.measurementInfo.interval) || isNaN(updatedEquipment.measurementInfo.interval)) {
    newErrors[actualID] = "not.empty";
  } else if (parseFloat(updatedEquipment.measurementInfo.interval) < newEquipmentInterMeasurement[indexEquipment]) {
    newErrors[actualID] = "not.higher.than.amount.measurement.time.channels";
  } else if (parseFloat(updatedEquipment.measurementInfo.interval) > 86400) {
    newErrors[actualID] = "not.higher.than.day";
  } else {
    delete newErrors[actualID];
  }
  setErrors(newErrors);
  newEquipments[indexEquipment] = updatedEquipment;
  setEquipment(newEquipments);
  setEquipmentInterMeasurement(newEquipmentInterMeasurement);
};

export async function offsetPolygonPerSegment(polyline, distance1, distance2, intl) {
  const points = polyline.points
    .map((line, lineIndex) => (polyline.must_graph_points.includes(lineIndex) ? [line.lat, line.lng] : null))
    .filter(Boolean);
  const newPoints = [];
  for (let index = 0; index < points.length; index++) {
    const point = [points[index][1], points[index][0]];
    let isOnLand = false;
    for (const feature of worldLand.features) {
      if (turf.booleanPointInPolygon(point, feature)) {
        isOnLand = true;
        break;
      }
    }
    if (!isOnLand) {
      newPoints.push([points[index][0], points[index][1]]);
    }
  }
  if (!isEmpty(newPoints)) {
    // Convertir a línea GeoJSON
    const line = turf.lineString(newPoints);

    // Buffers en metros
    const criticalBuffer = turf.buffer(line, distance1 / 1000, { units: "kilometers" });
    const protectBuffer = turf.buffer(line, distance2 / 1000, {
      units: "kilometers",
    });

    // Convertir a formato Leaflet (lat, lng)
    const criticalCoords = criticalBuffer.geometry.coordinates[0];
    const protectCoords = protectBuffer.geometry.coordinates[0];

    //const finalCritical = [];
    //let lastSeaCritical = false;
    //let lastLandCritical = false;
    //const seaIndexCritical = [];
    //const landIndexCritical = [];
    //for (let indexCritical = 0; indexCritical < criticalCoords.length; indexCritical++) {
    //  const point = [criticalCoords[indexCritical][1], criticalCoords[indexCritical][0]];
    //  let isOnLand = false;
    //  for (const feature of worldLand.features) {
    //    if (turf.booleanPointInPolygon(point, feature)) {
    //      isOnLand = true;
    //      lastLandCritical = true;
    //      if (lastSeaCritical) {
    //        seaIndexCritical.push({
    //          index: indexCritical,
    //          point: [criticalCoords[indexCritical][0], criticalCoords[indexCritical][1]],
    //        });
    //      }
    //      lastSeaCritical = false;
    //      break;
    //    }
    //  }
    //
    //  if (!isOnLand) {
    //    lastSeaCritical = true;
    //    if (lastLandCritical) {
    //      landIndexCritical.push({
    //        index: indexCritical,
    //        point: [criticalCoords[indexCritical][0], criticalCoords[indexCritical][1]],
    //      });
    //    }
    //    lastLandCritical = false;
    //    finalCritical.push([criticalCoords[indexCritical][0], criticalCoords[indexCritical][1]]);
    //  }
    //}
    //
    ////const seaInterCritical = getIntersect(seaIndexCritical, criticalCoords);
    ////const landInterCritical = getIntersect(landIndexCritical, criticalCoords);
    //
    //const newCritical = [];
    ////const newCritical = completePolygon(
    ////  criticalCoords,
    ////  seaIndexCritical,
    ////  landIndexCritical,
    ////  seaInterCritical,
    ////  landInterCritical,
    ////);
    //
    //const finalProtect = [];
    //let lastSeaProtect = false;
    //let lastLandProtect = false;
    //const seaIndexProtect = [];
    //const landIndexProtect = [];
    //
    //for (let indexProtect = 0; indexProtect < protectCoords.length; indexProtect++) {
    //  const point = [protectCoords[indexProtect][1], protectCoords[indexProtect][0]];
    //  let isOnLand = false;
    //  for (const feature of worldLand.features) {
    //    if (turf.booleanPointInPolygon(point, feature)) {
    //      isOnLand = true;
    //      lastLandProtect = true;
    //      if (lastSeaProtect) {
    //        seaIndexProtect.push({
    //          index: indexProtect,
    //          point: [protectCoords[indexProtect][0], protectCoords[indexProtect][1]],
    //        });
    //      }
    //      lastSeaProtect = false;
    //      break;
    //    }
    //  }
    //
    //  if (!isOnLand) {
    //    lastSeaProtect = true;
    //    if (lastLandProtect) {
    //      landIndexProtect.push({
    //        index: indexProtect,
    //        point: [protectCoords[indexProtect][0], protectCoords[indexProtect][1]],
    //      });
    //    }
    //    lastLandProtect = false;
    //    finalProtect.push([protectCoords[indexProtect][0], protectCoords[indexProtect][1]]);
    //  }
    //}
    //
    //const seaInter = getIntersect(seaIndexProtect, protectCoords);
    //const landInter = getIntersect(landIndexProtect, protectCoords);
    //
    //console.log(seaInter, landInter);
    //
    //const newProtect = completePolygon(protectCoords, seaIndexProtect, landIndexProtect, seaInter, landInter);

    return { criticalCoords: criticalCoords, protectCoords: protectCoords };
  } else {
    return null;
  }
}
function esTridimensional(arr) {
  return (
    Array.isArray(arr) &&
    arr.every((nivel1) => Array.isArray(nivel1) && nivel1.every((nivel2) => Array.isArray(nivel2)))
  );
}

export function toPolygon(coords) {
  // convertir lat/lng → lng/lat
  const ring = coords.map(([lat, lng]) => [lng, lat]);

  // cerrar polígono
  const first = ring[0];
  const last = ring[ring.length - 1];

  if (first[0] !== last[0] || first[1] !== last[1]) {
    ring.push(first);
  }

  return turf.polygon([ring]);
}

export function coordsToLatLng(coords, type) {
  if (type === "Polygon") {
    return coords.map((ring) => ring.map(([lng, lat]) => [lat, lng]));
  }

  if (type === "MultiPolygon") {
    return coords.map((polygon) => polygon.map((ring) => ring.map(([lng, lat]) => [lat, lng])));
  }

  return null;
}

// Versión mejorada de getIntersect
function getIntersect(indexArrays, coordinates) {
  const intersections = [];
  const territoryCounters = {}; // ← contador por isla/provincia

  for (let index = 0; index < indexArrays.length; index++) {
    intersections.push([]);
    const idx = indexArrays[index].index;

    const point = [coordinates[idx][1], coordinates[idx][0]];
    const lastPoint =
      idx === 0
        ? [coordinates[coordinates.length - 1][1], coordinates[coordinates.length - 1][0]]
        : [coordinates[idx - 1][1], coordinates[idx - 1][0]];

    const line = turf.lineString([lastPoint, point]);

    for (const feature of worldLand.features) {
      const multipolygon = feature.geometry.coordinates;
      const provCode = feature.properties.prov_code;

      for (let islandIndex = 0; islandIndex < multipolygon.length; islandIndex++) {
        const coords = multipolygon[islandIndex];
        const aux = esTridimensional(coords);
        const test = !aux ? [coords] : coords;

        const poly = turf.polygon(test, feature.properties);
        const auxCoords = poly.geometry.coordinates[0];

        for (let i = 0; i < auxCoords.length - 1; i++) {
          const edge = turf.lineString([auxCoords[i], auxCoords[i + 1]]);
          const inter = turf.lineIntersect(line, edge);

          if (inter.features.length > 0) {
            // Generamos un ID base de isla
            const baseId = `${provCode}_${islandIndex}`;
            // Contador incremental
            if (!territoryCounters[baseId]) territoryCounters[baseId] = 0;
            const count = territoryCounters[baseId]++;
            // ID único de territorio+conteo
            const territoryId = `${baseId}_${count}`;

            intersections[index].push({
              index: i,
              point: inter.features[0].geometry.coordinates,
              coord: poly.geometry.coordinates[0],
              provincia: poly.properties.prov_name,
              comunidad: poly.properties.acom_name,
              codigo: provCode,
              islaIndex: islandIndex,
              territoryId, // 👈 identificador único incremental
              baseId, // 👈 identificador simple por isla
            });
          }
        }
      }
    }
  }

  return intersections;
}

function completePolygon(coordinates, seaIndex, landIndex, seaIntersection, landIntersection) {
  const newPolygon = [...coordinates];
  console.log(newPolygon.map((coord) => [coord[1], coord[0]]));
  for (let indexSeaIntersection = 0; indexSeaIntersection < seaIntersection.length; indexSeaIntersection++) {
    if (indexSeaIntersection > 0 || seaIntersection.length <= 2 || seaIntersection.length < 5) {
      const coordIndex = seaIntersection[indexSeaIntersection][0].index;
      const seaTerritoryId = seaIntersection[indexSeaIntersection]?.[0]?.territoryId;

      const auxIndex = landIntersection.findIndex(
        (li) => Array.isArray(li) && li.some((item) => item?.territoryId === seaTerritoryId),
      );
      const realSecondIndex =
        indexSeaIntersection === 0 || seaIntersection.length <= 2
          ? indexSeaIntersection
          : !isNil(landIntersection[seaIntersection.length - indexSeaIntersection])
            ? seaIntersection.length - indexSeaIntersection
            : seaIntersection.length - indexSeaIntersection - 1;
      const twoIndexes =
        coordIndex > landIntersection[auxIndex][0].index
          ? [landIntersection[auxIndex][0].index, coordIndex]
          : [coordIndex, landIntersection[auxIndex][0].index];
      const coords = seaIntersection[indexSeaIntersection][0].coord;
      const [start, end] = twoIndexes;

      // calculamos longitudes de los dos tramos posibles
      const directLength = end - start;
      const complementLength = coords.length - directLength;

      let landSlice;

      if (directLength <= complementLength) {
        // camino directo
        landSlice = coords.slice(start, end);
      } else {
        // camino complementario (del 0 al start, y del end al final)
        landSlice = [...coords.slice(end), ...coords.slice(0, start)];
      }
      const coordsLatLon = landSlice.map(([lon, lat]) => [lat, lon]);
      let twoIndexesCoords =
        seaIndex[indexSeaIntersection].index > landIndex[auxIndex].index
          ? [landIndex[auxIndex], seaIndex[indexSeaIntersection]]
          : [seaIndex[indexSeaIntersection], landIndex[auxIndex]];
      //if (seaIndex[indexSeaIntersection].index > landIndex[landIndex.length - 1 - indexSeaIntersection].index) {
      //  coordsLatLon.reverse();
      //}
      console.log(coordsLatLon.map((coord) => [coord[1], coord[0]]));
      if (indexSeaIntersection > 0) {
        const newIndex1 = newPolygon.findIndex(
          (c) => c[0] === twoIndexesCoords[0].point[0] && c[1] === twoIndexesCoords[0].point[1],
        );
        const newIndex2 = newPolygon.findIndex(
          (c) => c[0] === twoIndexesCoords[1].point[0] && c[1] === twoIndexesCoords[1].point[1],
        );
        if (newIndex1 - newIndex2 < 0) {
          const directLength2 = newIndex2 - newIndex1;
          const complementLength2 = newPolygon.length - directLength2;

          if (directLength2 > complementLength2) {
            const bigOne = Math.max(...[newIndex1, newIndex2]);
            const smallOne = Math.min(...[newIndex1, newIndex2]);
            newPolygon.splice(0, smallOne); // elimina todo antes de newIndex1
            newPolygon.splice(bigOne - smallOne);
            newPolygon.push(...coordsLatLon);
          } else {
            newPolygon.splice(newIndex1, newIndex2 - newIndex1 + 1, ...coordsLatLon);
          }
        } else if (newIndex1 >= 0 && newIndex2 >= 0) {
          if (newIndex2 < 30 && newPolygon.length - newIndex1 < 30) {
            const bigOne = Math.max(...[newIndex1, newIndex2]);
            const smallOne = Math.min(...[newIndex1, newIndex2]);
            newPolygon.splice(0, smallOne); // elimina todo antes de newIndex1
            newPolygon.splice(bigOne - smallOne);
            newPolygon.push(...coordsLatLon);
          } else {
            newPolygon.splice(newIndex2, newIndex1 - newIndex2 + 1, ...coordsLatLon);
          }
        }
      } else {
        const finalCoordsAddition =
          twoIndexesCoords[0].point[1] > twoIndexesCoords[1].point[1] &&
          coordsLatLon[coordsLatLon.length - 1][1] > coordsLatLon[0][1]
            ? coordsLatLon.reverse()
            : coordsLatLon;
        if (
          (twoIndexesCoords[0].index - 1 < 30 && newPolygon.length - twoIndexesCoords[1].index < 30) ||
          (twoIndexesCoords[1].index - 1 < 30 && newPolygon.length - twoIndexesCoords[0].index - 1 < 30)
        ) {
          const bigOne = Math.max(...[twoIndexesCoords[0].index - 1, twoIndexesCoords[1].index]);
          const smallOne = Math.min(...[twoIndexesCoords[0].index - 1, twoIndexesCoords[1].index]);
          newPolygon.splice(0, smallOne); // elimina todo antes de newIndex1
          newPolygon.splice(bigOne - smallOne);
          newPolygon.push(...finalCoordsAddition);
        } else {
          newPolygon.splice(
            twoIndexesCoords[0].index - 1,
            twoIndexesCoords[1].index - twoIndexesCoords[0].index + 1,
            ...finalCoordsAddition,
          );
        }
      }
      console.log(newPolygon.map((coord) => [coord[1], coord[0]]));
    }
  }
  return newPolygon;
}
